import { CalendarCheck, BookOpen, Gift } from "lucide-react";
import AppointmentDialog from "./AppointmentDialog";

/** The in-person paperback offer, kept visually separate from the free digital copies. */
const PaperbackOffer = ({ className = "" }: { className?: string }) => (
  <div className={`bg-brand-ivory border border-primary/25 p-6 sm:p-8 md:p-10 ${className}`}>
    <div className="grid md:grid-cols-[minmax(0,1fr)_auto] gap-6 md:gap-10 items-center">
      <div className="min-w-0">
        <p className="eyebrow mb-3 inline-flex items-center gap-2">
          <Gift className="h-4 w-4" strokeWidth={1.5} /> Prefer a paperback?
        </p>
        <p className="font-serif text-xl md:text-2xl font-light text-foreground leading-snug">
          Book a free, no-obligation, in-person appointment with John, and he'll bring you a complimentary 100+ page
          book—<span className="italic text-primary">a $19.99 value.</span>
        </p>
        <ul className="mt-5 grid sm:grid-cols-2 gap-3 text-sm text-muted-foreground font-light">
          <li className="flex items-start gap-2">
            <BookOpen className="h-4 w-4 text-primary mt-0.5 shrink-0" strokeWidth={1.5} />
            <span><span className="text-foreground font-normal">Digital copy:</span> free, online, right away.</span>
          </li>
          <li className="flex items-start gap-2">
            <CalendarCheck className="h-4 w-4 text-primary mt-0.5 shrink-0" strokeWidth={1.5} />
            <span><span className="text-foreground font-normal">Paperback:</span> John hands it to you at your appointment.</span>
          </li>
        </ul>
      </div>
      <AppointmentDialog
        trigger={
          <button
            type="button"
            className="inline-flex items-center justify-center gap-3 bg-primary text-primary-foreground px-6 sm:px-8 py-4 text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase hover:bg-primary/90 transition-all w-full md:w-auto md:whitespace-nowrap"
          >
            <CalendarCheck className="h-4 w-4" /> Book an Appointment
          </button>
        }
      />
    </div>
  </div>
);

export default PaperbackOffer;
